import { Link } from "react-router-dom";

const Jobdata =
[
  {
    id:'1',
    Job: 'MPESB Pre Veterinary and Fisheries Test',
    qualification:'qualification',
    qualification2:'Passed/Appearing 10+2 Intermediate Exam with PCB Stream And English as a Subject.',
    postno:'MPESB PVFT',
    age:'Between 17 Years',
    date:'21-Jun-2023',
    post:'Job Details',
    content:'The MPESB PVFT is a state-level entrance exam held for admission to B.F.Sc. (Bachelor of Fisheries Science) and B.V.Sc and A.H. (Bachelor of Veterinary Science and Animal Husbandry) courses offered in different colleges.',
    category:'IT',
    // link:'https://www.sarkariresult.com/mp/mp-esb-pvft-2023/',
    link:<Link to="https://www.sarkariresult.com/mp/mp-esb-pvft-2023/" target="_blank">For More Details..</Link>,
    ago:' 4 Days Ago'
  },
  {
    id:'2',
    Job: 'Reserve Bank RBI (Junior Engineer JE Civil/Electrical)',
    qualification:'qualification',
    qualification2:'Diploma in Civil/Electrical Engineering',
    postno:'35 Posts',
    ago:' 4 Days Ago',
    age:'Between 20 To 30 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    content:'RBI JE Notification 2023 has been released. The Reserve Bank of India (RBI)has announced 35 vacancies for the post of Junior Engineer in Civil and Electrical Engineering disciplines. This is a great opportunity for Engineering graduates.',
    // link:'https://www.dopmah.in/rbi-junior-engineer-recruitment-2023/',
    link:<Link to="https://www.dopmah.in/rbi-junior-engineer-recruitment-2023/" target="_blank">For More Details..</Link>,
    category:'IT',
  },
  {
    id:'3',
    Job: 'MHA Intelligence Bureau IB(Junior Intelligence Officer JIO/Technical)',
    qualification:'qualification',
    qualification2:'B.SC in Electronics or Computer Science',
    postno:'797 Posts',
    ago:' 4 Days Ago',
    age:'Between 18 TO 27 Years',
    date:'23-Jun-2023',
    post:'Job Details',
    content:'MHA has introduced 797 vacancies for Junior Intelligence Officer and Technical this year. Overall, 797 vacancies are for JIO/Technical posts. Check the category-sensible emptiness information to submit JIO/Technical underneath IB Recruitment 2023.',
    // link: "https://www.sarkariresult.com/2023/mha-ib-jio-june23/",
    link:<Link to="https://www.sarkariresult.com/2023/mha-ib-jio-june23/" target="_blank">For More Details..</Link>,
    category:'IT',
  },
  {
    id:'4',
    Job: 'CSBC Bihar Police Constables Recruitment(Police Constable Recruitment 2023)',
    qualification:'qualification',
    qualification2:'10+2 Intermediate Exam In Any Recognized Board in India.',
    postno:'21391 Posts',
    ago:' 4 Days Ago',
    age:'Between 18 To	25 Years',
    date:'20-Jul-2023',
    post:'Job Details',
    // link:'https://haryanajobs.in/bihar-police-constable-vacancy-2023/',
    link:<Link to='https://haryanajobs.in/bihar-police-constable-vacancy-2023/' target="_blank">For More Details..</Link>,
    content:'Eligible Male and Female candidates can apply online for the CSBC Bihar Police Constable Recruitment 2023 from the website csbc.bih.nic.in starting from June 20, 2023.',
    category:'IT',
  },
  {
    id:'5',
    Job: 'NHPC Limited (NHPC India) & THDC India Ltd',
    qualification:'qualification',
    qualification2:'3 Year Engineering Diploma, Diploma in Surveying / Survey Engineering',
    postno:'569 Posts',
    ago:' 4 Days Ago',
    age:'Between 30 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17413',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17413' target="_blank">For More Details..</Link>,
    content:'NHPC limited & THDC India ltd released a new notification for the requirements of junior engineer and various other posts post on the official website NHPC and THDC.as per the notification online application process for NHPC limited & THDC india ltd . ',
    category:'IT',
  },
  {
    id:'6',
    Job: 'Join Indian Navy 10+2 B.Tech Entry',
    qualification:'qualification',
    qualification2:'Passed 10+2 Exam',
    postno:'30 Posts',
    ago:' 4 Days Ago',
    age:'--',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17410',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17410' target="_blank">For More Details..</Link>,
    content:'The Indian Navy has opened its doors to young aspirants with the (10+2) B.Tech Cadet Entry 2023 for the January 2024 batch. If you are a 10+2 pass with PCM and dream of serving the nation while working with state-of-the-art technology.',
    category:'IT',
  },
  {
    id:'7',
    Job: 'UPSSSC X Ray Technician Recruitment',
    qualification:'qualification',
    qualification2:'UPSSSC PET 2022 Score Card, Diploma in X Ray Technician Exam.',
    postno:'382 Posts',
    ago:' 4 Days Ago',
    age:'Between 18 To 40 Years',
    date:'5-Jul-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17405',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17405' target="_blank">For More Details..</Link>,
    content:'This is a great opportunity for individuals who have a diploma in X-Ray Technician or an equivalent field.The successful candidates will play a crucial role in the medical field, providing essential diagnostic information through X-Ray imaging.',
    category:'IT',
  },
  {
    id:'8',
    Job: 'Delhi Development Authority (DDA)',
    qualification:'qualification',
    qualification2:'10+2 Intermediate, Diploma in Civil, Bachelor Degree, MBA Finance / CA / CS',
    postno:'687 Posts',
    ago:' 4 Days Ago',
    age:'Between 18 To	35 Years',
    date:'2-Jul-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17399',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17399' target="_blank">For More Details..</Link>,
    content:'Recruitment :- Naib Tehsildar, Surveyor, Legal Assistant, Junior Engineer Civil, Assistant Section Officer ASO, Patwari,',
    category:'IT',
  },
  {
    id:'9',
    Job: 'Join Indian Army (Bhartiya Sena)',
    qualification:'qualification',
    qualification2:'JEE Mains 2023 has been made Mandatory from Indian Army TES 50 Course',
    postno:'50 Posts',
    ago:' 4 Days Ago',
    age:'Between 16.6 To	19.6 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17396',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17396' target="_blank">For More Details..</Link>,
    content:'Army 10+2 Technical Entry Scheme Course TES 50',
    category:'IT',
  },
  {
    id:'10',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'IT',
  },

  // -------------------- Bank Job --------------------------------- //

  {
    id:'10',
    Job: 'Reserve Bank RBI (Junior Engineer JE Civil/Electrical)',
    qualification:'qualification',
    qualification2:'Diploma in Civil/Electrical Engineering',
    postno:'35 Posts',
    ago:' 4 Days Ago',
    age:'Between 20 To 30 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    content:'RBI JE Notification 2023 has been released. The Reserve Bank of India (RBI)has announced 35 vacancies for the post of Junior Engineer in Civil and Electrical Engineering disciplines. This is a great opportunity for Engineering graduates.',
    // link:'https://www.dopmah.in/rbi-junior-engineer-recruitment-2023/',
    link:<Link to='https://www.dopmah.in/rbi-junior-engineer-recruitment-2023/' target="_blank">For More Details..</Link>,
    category:'Bank',
  },
  {
    id:'11',
    Job: 'IBPS RRB XII Recruitment',
    qualification:'qualification',
    qualification2:'Degree in CA OR MBA',
    postno:'8611 Posts',
    ago:' 4 Days Ago',
    age:'Between 18 To 40 Years',
    date:'21-Jun-2023',
    post:'Job Details',
    content:'IBPS Rural Regional Bank (RRB) XII Recruitment 2023',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17384',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17384' target="_blank">For More Details..</Link>,
    category:'Bank',
  },

  // -------------------- Defence Job --------------------------------- //

  {
    id:'12',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Defence',
  },

  // -------------------- Railway Job --------------------------------- //
  
  {
    id:'13',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Railway',
  },
  {
    id:'14',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Railway',
  },
  {
    id:'15',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Railway',
  },
  {
    id:'16',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Railway',
  },
  {
    id:'17',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Railway',
  },

  // -------------------- Police Job --------------------------------- //

{
    id:'18',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Police',
  },
  {
    id:'19',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Police',
  },
  {
    id:'20',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Police',
  },
  {
    id:'21',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Police',
  },

  // -------------------- Judicial Job --------------------------------- //

  {
    id:'22',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Judicial',
  },
  {
    id:'23',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Judicial',
  },
  {
    id:'24',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Judicial',
  },
  {
    id:'25',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'Judicial',
  },

  // -------------------- upsc Job --------------------------------- //

  {
    id:'26',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'upsc',
  },
  {
    id:'27',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'upsc',
  },
  {
    id:'28',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'upsc',
  },
  {
    id:'30',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'upsc',
  },


  //--------------------------- SSC Job -------------------//

  {
    id:'31',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'SSC',
  },

//------------ State PSC job --------//
  {
    id:'32',
    Job: 'Indian Air Force (Bhartiya Vayu Sena)',
    qualification:'qualification',
    qualification2:'10+2 Level / B.E / B.Tech Course',
    postno:'276 Posts',
    ago:' 4 Days Ago',
    age:'Between 20	To 26 Years',
    date:'30-Jun-2023',
    post:'Job Details',
    // link:'http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369',
    link:<Link to='http://www.kirannewsagency.com/job/jobsgetdetails.aspx?cjobid=17369' target="_blank">For More Details..</Link>,
    content:' Ground Duty Non Technical, NCC Special Entry, AFCAT, Ground Duty Technical',
    category:'PSC',
  },
]
export default Jobdata;
